class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search__results');
    this.overlay = this.querySelector('.predictive-search__overlay');
    this.isOpen = false;
    this.controller = new AbortController();
    this.working = false;
    this.hasPlaceholder = false;
    this.timeoutQuery;
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', (event) => {
      if (window.innerWidth < 750) {
        document.querySelector('.header-wrapper').scrollIntoView({
          behavior: 'smooth', 
          block: 'start'
        });
      }
      this.open();
      this.setLiveRegionLoadingState();
      if(this.timeoutQuery) {
        clearTimeout(this.timeoutQuery);
        this.working = false;
      }
      this.timeoutQuery = setTimeout(this.onChange.bind(this), 300);
    });
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.overlay.addEventListener('click', this.onClickOverlay.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) {
      this.querySelector(".predictive-search__results-suggestions").classList.remove("hidden")
      this.querySelector(".predictive-search__results-generated").classList.add("hidden")
    } else {
      this.querySelector(".predictive-search__results-suggestions").classList.add("hidden")
      this.querySelector(".predictive-search__results-generated").classList.remove("hidden")
    }
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    this.open();

    this.lockScroll()
    document.querySelector(".header").classList.add(`force-header-top`);
    this.header = this.header || document.querySelector('.section-header');
    this.headerContent = document.querySelector('.header');
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.headerContent.getBoundingClientRect().bottom)}px`);

    if (!searchTerm.length) {
      this.querySelector(".predictive-search__results-suggestions").classList.remove("hidden")
      this.querySelector(".predictive-search__results-generated").classList.add("hidden")
    } else {
      this.querySelector(".predictive-search__results-suggestions").classList.add("hidden")
      this.querySelector(".predictive-search__results-generated").classList.remove("hidden")
    }

    if (this.getAttribute('results') === 'true') {
      // this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onClickOverlay() {
    this.close();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    
    if (!this.working) {
      this.controller.abort();
      this.controller = new AbortController();
    }
    const signal = this.controller.signal;
    this.working = true;

    const client = algoliasearch('QCNY1XYTZF', '3efc3d956ce6cda98bb9bc7bdcd516be');
    const indexProducts = client.initIndex('shopify_products');

    console.log("searchTerm", searchTerm, "signal", signal)

    const productSearchPromise = Promise.resolve(indexProducts.search(searchTerm, { hitsPerPage: 10, attributesToRetrieve: ['title', 'product_image', 'product_type', 'price', 'compare_at_price', 'handle'] }));
    const collectionSearchPromise = client.initIndex('shopify_collections').search(searchTerm, { hitsPerPage: 10 });

    Promise.all([productSearchPromise, collectionSearchPromise])
      .then(([productResults, collectionResults]) => {
        this.cachedResults[queryKey] = productResults.hits;
        this.renderSearchResults(productResults.hits, searchTerm);
      })
      .catch((error) => {
        this.close();
        console.error("Search error:", error);
      })
      .finally(() => {
        this.working = false;
      });
  }

  setLiveRegionLoadingState() {
    this.setAttribute('loading', true);
    if(!this.hasPlaceholder) {
      const temp = document.getElementById("predictive-search-placeholder-tpl");
      const placeholder = temp.content.cloneNode(true);
      this.querySelector('.predictive-search__loading-state').append(placeholder);
      this.hasPlaceholder = true;
    }
  }

  renderSearchResults(hits, searchTerm) {
    const client = algoliasearch('QCNY1XYTZF', '3efc3d956ce6cda98bb9bc7bdcd516be');
    
    // Create promises for both product and collection searches
    const productSearchPromise = Promise.resolve(hits); // Use the already fetched product hits
    const collectionSearchPromise = client.initIndex('shopify_collections').search(searchTerm, { hitsPerPage: 5 });

    Promise.all([productSearchPromise, collectionSearchPromise])
      .then(([productHits, collectionResults]) => {
        // Log each collection hit
        collectionResults.hits.forEach(hit => {
          console.log("collection hit", hit);
        });

        // Render the product search results
        this.predictiveSearchResults.innerHTML = `
        <a href="${window.routes.search_url}?q=${searchTerm}&options%5Bprefix%5D=last" tabindex="-1" role="option" aria-selected="false" class="predictive-search__header h5 margin0 link w100 flex justify-space-between align-center break">
          <span>Ergebnisse für "${searchTerm}"</span> 
          <svg class="icon icon-revert-in-rtl icon-revert-in-rtl" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M14 5L21 12M21 12L14 19M21 12L3 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </a>
        ${collectionResults.hits.length > 0 ? `
        <div class="predictive-search__results-list flex flex-column element-small-margin-top">
           <div class="predictive-search__group predictive-search__group--with-media predictive-search__group--collection">
            <h3 class="predictive-search__heading predictive-search__padding caption lh1 font-heading-bold margin0">Kategorien</h3>
            <ul class="list-unstyled predictive-search__item-list flex flex-column">
            ${collectionResults.hits.map(hit => `
                  <li>
                    <a class="predictive-search__collection predictive-search__item por full-unstyled-link predictive-search__item--empty" href="${Shopify.locale !== 'de' ? '/' + Shopify.locale : ''}/collections/${hit.handle}">
                      <div class="predictive-search__item__info">
                        <p class="h6 predictive-search__item__title card__heading">
                          ${hit._highlightResult.title.value}
                        </p>
                        <div class="margin-top-1rem">
                          <span class="caption db font-heading-bold light">
                            
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                `).join('')}
            </ul>
          </div>
        </div>
        ` : ''}
        ${productHits.length > 0 ? `
          <div class="predictive-search__group predictive-search__group--with-media">
            <h3 class="predictive-search__heading predictive-search__padding caption lh1 font-heading-bold margin0">Produkte</h3>
            <ul class="list-unstyled predictive-search__item-list flex flex-column">
              ${productHits.map(hit => `
                <li>
                  <a class="predictive-search__product predictive-search__item por full-unstyled-link" href="${Shopify.locale !== 'de' ? '/' + Shopify.locale : ''}/products/${hit.handle}">
                    <div class="predictive-search__product__media-wrapper">
                      <use-animate class="media media--square">
                        <img src="${hit.product_image}" width="150" height="150" class="predictive-search__product__image motion-reduce" loading="lazy">
                      </use-animate>
                    </div>
                    <div class="predictive-search__item__info">
                      <p class="h6 predictive-search__item__title card__heading font-heading-bold">
                        ${hit.title}
                      </p>
                      <p class="caption predictive-search__item__type">
                        ${hit.product_type}
                      </p>
                      <div class="margin-top-1rem">
                        <div class="price ${hit.compare_at_price > hit.price ? 'price--on-sale' : ''} price--small">
                          <div class="price__container${hit.compare_at_price > hit.price ? ' break' : ''}">
                            <div class="price__regular">
                              <span class="visually-hidden visually-hidden--inline">Regular Price</span>
                              <span class="price-item price-item--regular ${hit.free_addon ? 'free-addon' : ''}">
                                ${hit.price.toFixed(2)} €
                              </span>
                            </div>
                            ${hit.compare_at_price > hit.price ? `
                            <div class="price__sale">
                              <span class="visually-hidden visually-hidden--inline">Regular Price</span>
                              <span class="flex align-center">
                                <s class="price-item price-item--regular">
                                  ${hit.compare_at_price.toFixed(2)} €
                                </s>
                              </span>
                              <span class="visually-hidden visually-hidden--inline">Sale Price</span>
                              <span class="price-item price-item--sale price-item--last">
                                ${hit.price.toFixed(2)} €
                              </span>
                            </div>
                            ` : ''}
                            ${hit.variants_count > 0 && hit.variants_min_price !== hit.variants_max_price ? `
                            <small class="unit-price caption">
                              <span class="visually-hidden">Unit Price</span>
                              <span class="price-item price-item--last">
                                ${hit.variants_min_price.toFixed(2)} € - ${hit.variants_max_price.toFixed(2)} €
                              </span>
                            </small>
                            ` : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              `).join('')}
            </ul>
          </div>
           ` : ''}
        </div>
        <div class="center predictive-search__search-url element-small-margin-top break">
          <a href="${window.routes.search_url}?q=${searchTerm}&options%5Bprefix%5D=last" class="predictive-search__button">
            <span>Alle Ergebnisse anzeigen</span>
          </a>
        </div>
        <div class="predictive-search__shadow">
        </div>
        `; 
        this.setAttribute('results', true);
        this.setLiveRegionResults();
      })
      .catch((error) => {
        console.error("Search error:", error);
      });
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
  }

  open() {
    if(!this.isOpen) {
      if(!this.classList.contains('run-top')) {
        if(!this.timeoutRunTop) {
          this.timeoutRunTop = setTimeout(() => {
            this.classList.add('run-top');
            this.timeoutRunTop = null;
          }, 500);
        }
      }
      
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }
  }

  lockScroll() {
    document.documentElement.classList.add('overflow-hidden-mobile'); // html
    document.body.classList.add('overflow-hidden-mobile'); // body
  }

  unlockScroll() {
    document.documentElement.classList.remove('overflow-hidden-mobile'); // html
    document.body.classList.remove('overflow-hidden-mobile'); // body
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    this.unlockScroll()
    document.querySelector(".header").classList.remove(`force-header-top`);
    
    this.classList.remove('run-top');

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
   
    this.isOpen = false;
    if(this.nextElementSibling && this.nextElementSibling.classList.contains('search-modal__close-button')) {
      this.nextElementSibling.dispatchEvent(new Event('click'));
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.media--hover-effect, .full-unstyled-link').forEach(link => {
    let startX, startY;

    link.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    link.addEventListener('touchend', function(e) {
      const dx = Math.abs(e.changedTouches[0].clientX - startX);
      const dy = Math.abs(e.changedTouches[0].clientY - startY);
      // only treat it as a tap if finger didn’t move more than 10px
      if (dx < 10 && dy < 10) {
        window.location = this.href;
      }
    });
  });
}); 